// @flow
import type { SearchQuery, SortOrder } from './types';
export const DefaultPaginationPageSize = 100;

export function createNextPageQuery(
  lastUgcCreatedTime: string,
  query: SearchQuery,
  pageSize: number = DefaultPaginationPageSize
): SearchQuery {
  const { sort_order } = query;

  if (sort_order === ('desc': SortOrder)) {
    return {
      ...query,
      end_date: lastUgcCreatedTime,
    };
  }

  if (sort_order === ('asc': SortOrder)) {
    return {
      ...query,
      start_date: lastUgcCreatedTime,
    };
  }

  return query;
}

export function calculatePaginationDisplay({
  currentPage,
  currentPageCount,
  totalPages,
  getPageCount,
}: {
  currentPage: number,
  currentPageCount: number,
  totalPages?: number,
  getPageCount: (pageNum: number) => number,
}): {
  first: number,
  last: number,
  total: number,
  potentiallyMoreItems: boolean,
} {
  // Calculate running totals from actual page sizes
  let itemsBefore = 0;
  for (let i = 1; i < currentPage; i++) {
    itemsBefore += getPageCount(i);
  }

  // Calculate total across all loaded pages
  let total = itemsBefore + currentPageCount;
  let maxLoadedPage = currentPage;

  // Check if there are more pages loaded beyond current
  let nextPage = currentPage + 1;
  while (true) {
    const nextPageCount = getPageCount(nextPage);
    if (nextPageCount === 0) break;
    total += nextPageCount;
    maxLoadedPage = nextPage;
    nextPage++;
  }

  const first = itemsBefore + 1;
  const last = itemsBefore + currentPageCount;

  const hasMorePages =
    typeof totalPages === 'number' && totalPages > currentPage;
  const lastPageCount = getPageCount(maxLoadedPage);
  const potentiallyMoreItems =
    hasMorePages ||
    (typeof lastPageCount === 'number' &&
      lastPageCount >= DefaultPaginationPageSize);

  return {
    first,
    last,
    total,
    potentiallyMoreItems,
  };
}



// WEBPACK FOOTER //
// ./src/containers/search/PaginationUtils.js